// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d6131f9c","543":"0c0706fe","735":"58f295f4"}[chunkId] + ".chunk.js";
};